import { action } from '@ember/object';
import { service } from '@ember/service';

import BuySyncAddon from '@databox/ember-integrations/lib/components/DataSourceBuySyncAddon/DataSourceBuySyncAddon';
import { create } from '@databox/ember-integrations/lib/components/Setup';

import type { PopupData, ReactIntegrations, Service } from 'webapp-types';

import didInsert from 'webapp/modifiers/did-insert';
import willDestroy from 'webapp/modifiers/will-destroy';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class SourcePopupBuySyncAddonComponent extends PopupInnerModalComponent<PopupData.Source.BuySyncIntervalAddon> {
	@service('react') declare reactService: Service.React;

	contentNode: ReactIntegrations.Root = null;

	@action
	setupView(node: HTMLElement) {
		this.contentNode = create(node as HTMLDivElement);

		const newProps = {
			...this.popupData,
			onRenderEnd: () => {
				this.reposition();
			},
		};

		this.reactService.render(this.contentNode, BuySyncAddon(newProps));
	}

	@action
	teardownView(): void {
		if (this.contentNode) {
			this.contentNode.unmount();
			this.contentNode = null;
		}
	}
	<template>
		<div {{didInsert this.setupView}} {{willDestroy this.teardownView}}></div>
	</template>
}
